/*
 * The messages panel (prototype: .mpScrim, .mp and the app's chat screen copied as .c-*,
 * messages-panel.html Inside option 2 with the prototype's header fix; the room marks and the
 * filter row from phone-signed-in/q1-both.html). Colors are theme tokens only.
 */
@layer telify {
  /* The page behind: dimmed and softly out of focus, BELOW the site header, so the header is never covered. */
  .scrim {
    position: fixed;
    top: var(--head-h);
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 50;
    background: rgba(var(--bg-page-rgb), 0.62);
    backdrop-filter: blur(7px) saturate(115%);
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.32s ease, visibility 0s linear 0.32s;
  }

  .open .scrim {
    opacity: 1;
    visibility: visible;
    transition: opacity 0.32s ease;
  }

  /* The panel: full height under the site header, from the right. */
  .panel {
    position: fixed;
    top: var(--head-h);
    right: 0;
    bottom: 0;
    z-index: 60;
    width: min(440px, 100%);
    display: flex;
    flex-direction: column;
    border-left: var(--line);
    box-shadow: var(--shadow-card);
    transform: translateX(104%);
    visibility: hidden;
    transition: transform 0.46s cubic-bezier(0.32, 0.72, 0, 1), visibility 0s linear 0.46s;
  }

  .open .panel {
    transform: none;
    visibility: visible;
    transition: transform 0.46s cubic-bezier(0.32, 0.72, 0, 1);
  }

  .panel:focus {
    outline: none;
  }

  /* The app's chat screen (ClientChatScreen.module.css), as the prototype copies it. */
  .page {
    --r-lg: 18px;
    position: relative;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: var(--bg-page);
    color: var(--text-primary);
  }

  .atmosphere {
    position: absolute;
    inset: 0;
    z-index: 0;
    background: var(--page-overlay, none), var(--page-image, none), var(--bg-page);
    pointer-events: none;
  }

  .screen {
    position: relative;
    z-index: 1;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  .hdr {
    flex-shrink: 0;
    display: grid;
    grid-template-columns: 44px 1fr 44px;
    align-items: center;
    gap: 10px;
    padding: 16px 18px 10px;
  }

  .logo {
    display: block;
    width: 36px;
    height: 36px;
    object-fit: contain;
  }

  .who {
    min-width: 0;
    text-align: center;
  }

  .whoName {
    margin: 0;
    font-family: var(--font-display);
    font-weight: 500;
    font-size: 24px;
    letter-spacing: -0.02em;
    line-height: 1.1;
    color: var(--text-primary);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Secure · Telegram under the name, each with its mark (q1-both.html .tw-leg). */
  .rooms {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 4px;
    font-size: 12px;
    color: var(--text-tertiary);
  }

  .leg {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .leg svg {
    width: 12px;
    height: 12px;
    flex: 0 0 auto;
  }

  .dot {
    margin: 0 6px;
    opacity: 0.6;
  }

  .close {
    appearance: none;
    -webkit-appearance: none;
    cursor: pointer;
    border: 1px solid rgba(var(--accent-rgb), 0.3);
    width: 44px;
    height: 44px;
    border-radius: 13px;
    background: var(--glass-bg-strong);
    backdrop-filter: var(--glass-blur);
    box-shadow: var(--glass-shadow);
    color: var(--chevron-color);
    display: grid;
    place-items: center;
  }

  .close svg {
    width: 19px;
    height: 19px;
    stroke-width: 2.6;
  }

  /* The filter row (the app chat's chips). */
  .chips {
    flex-shrink: 0;
    display: flex;
    gap: 6px;
    padding: 0 18px 8px;
    overflow-x: auto;
    scrollbar-width: none;
  }

  .chips::-webkit-scrollbar {
    display: none;
  }

  .chip {
    appearance: none;
    -webkit-appearance: none;
    border: 0;
    cursor: pointer;
    flex-shrink: 0;
    padding: 6px 12px;
    border-radius: 9999px;
    font-family: var(--font-body);
    font-size: 12px;
    font-weight: 500;
    color: var(--text-tertiary);
    background: var(--glass-bg);
    box-shadow: inset 0 0 0 1px rgba(var(--accent-light-rgb), 0.08);
  }

  .chip[aria-pressed='true'] {
    color: var(--accent-hot);
    background: rgba(var(--accent-rgb), 0.16);
    box-shadow: inset 0 0 0 1px rgba(var(--accent-rgb), 0.45);
  }

  .thread {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-anchor: none;
    overscroll-behavior: contain;
    scrollbar-width: none;
    display: flex;
    flex-direction: column-reverse;
  }

  .thread::-webkit-scrollbar {
    display: none;
  }

  .threadInner {
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 6px 18px 14px;
  }

  .threadInner > :first-child {
    margin-top: auto;
  }

  .stateRow {
    align-self: center;
    margin: auto 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    font-family: var(--font-body);
    font-size: 13px;
    color: var(--text-secondary);
    text-align: center;
  }

  .retryBtn {
    appearance: none;
    cursor: pointer;
    border: 0;
    padding: 10px 18px;
    border-radius: 14px;
    background: var(--accent-orb);
    color: var(--text-on-accent);
    font-family: var(--font-body);
    font-weight: 600;
  }

  .spinner {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 3px solid rgba(var(--accent-rgb), 0.2);
    border-top-color: var(--accent);
    animation: spin 0.8s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  .explain {
    position: relative;
    align-self: center;
    margin: auto 10px;
    padding: 18px 18px 16px;
    text-align: center;
    border-radius: var(--r-lg);
    background: var(--glass-bg-strong);
    backdrop-filter: var(--glass-blur);
    box-shadow: var(--glass-shadow);
  }

  .explain::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    padding: 1px;
    background: linear-gradient(135deg, rgba(var(--accent-light-rgb), 0.16) 0%, rgba(var(--accent-light-rgb), 0.03) 100%);
    -webkit-mask: linear-gradient(black 0 0) content-box, linear-gradient(black 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
  }

  .explainIcon {
    width: 50px;
    height: 50px;
    margin: 0 auto 10px;
    border-radius: 50%;
    background: radial-gradient(circle at 30% 28%, rgba(var(--accent-hot-rgb), 0.32) 0%, rgba(var(--accent-deep-rgb), 0.16) 100%);
    border: 1px solid rgba(var(--accent-rgb), 0.22);
    display: grid;
    place-items: center;
    color: var(--accent);
  }

  .explainIcon svg {
    width: 22px;
    height: 22px;
    stroke-width: 1.7;
  }

  .explainTitle {
    margin: 0 0 6px;
    font-family: var(--font-display);
    font-weight: 500;
    font-size: 19px;
    letter-spacing: -0.018em;
    color: var(--text-primary);
  }

  .explainBody {
    margin: 0;
    font-family: var(--font-body);
    font-size: 13px;
    line-height: 1.45;
    color: var(--text-secondary);
  }

  .day {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 8px 0 4px;
    font-family: var(--font-body);
    font-size: 10.5px;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--text-muted);
  }

  .day::before,
  .day::after {
    content: '';
    flex: 1;
    height: 1px;
    background: rgba(var(--fg-page-rgb), 0.08);
  }

  .msg {
    position: relative;
    max-width: 82%;
    padding: 10px 13px 8px;
    border-radius: 18px;
    font-family: var(--font-body);
    font-size: 14px;
    line-height: 1.38;
    letter-spacing: 0.002em;
    overflow-wrap: anywhere;
  }

  .text {
    white-space: pre-wrap;
  }

  .them {
    align-self: flex-start;
    border-bottom-left-radius: 6px;
    background: var(--glass-bg-strong);
    backdrop-filter: var(--glass-blur);
    box-shadow: var(--glass-shadow);
    color: var(--text-primary);
  }

  .them::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    padding: 1px;
    background: linear-gradient(135deg, rgba(var(--accent-light-rgb), 0.16) 0%, rgba(var(--accent-light-rgb), 0.03) 100%);
    -webkit-mask: linear-gradient(black 0 0) content-box, linear-gradient(black 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
  }

  .me {
    align-self: flex-end;
    border-bottom-right-radius: 6px;
    background: linear-gradient(160deg, var(--accent-hot) 0%, var(--accent) 55%, var(--accent-deep) 100%);
    color: var(--text-on-accent);
    box-shadow: 0 6px 18px rgba(var(--accent-shadow-rgb), 0.35);
  }

  .meta {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    margin-top: 4px;
    font-size: 10.5px;
    color: var(--text-tertiary);
  }

  .me .meta {
    min-width: calc(4.8em + 16px);
    color: color-mix(in srgb, var(--text-on-accent) 70%, transparent);
  }

  .meta svg {
    width: 12px;
    height: 12px;
    stroke-width: 2.6;
  }

  .me .meta svg {
    color: var(--text-on-accent);
  }

  /* The room mark before the time (q1-both.html .tw-mark): the lock, or the Telegram plane. */
  .mark {
    display: inline-flex;
    margin-right: 0;
    opacity: 0.75;
  }

  .meta .mark svg,
  .time .mark svg {
    width: 11px;
    height: 11px;
    stroke-width: 2.2;
  }

  /* Media the client sent through Telegram: a quiet line. */
  .sys {
    align-self: center;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-family: var(--font-body);
    font-size: 11.5px;
    color: var(--text-muted);
    text-align: center;
  }

  .auto {
    max-width: 86%;
    padding-bottom: 0;
  }

  .autoBody {
    white-space: pre-line;
  }

  .autoBody a,
  .foldPage a {
    color: var(--accent);
  }

  .showMore {
    appearance: none;
    -webkit-appearance: none;
    cursor: pointer;
    display: block;
    margin-top: 2px;
    padding: 2px 0;
    border: 0;
    background: none;
    font-family: var(--font-body);
    font-size: 12.5px;
    font-weight: 600;
    color: var(--accent);
  }

  .state {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    margin-top: 6px;
    font-size: 12px;
    color: var(--text-secondary);
  }

  .state svg {
    width: 12px;
    height: 12px;
    stroke-width: 2.4;
    color: var(--accent);
  }

  .foot {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin: 8px -13px 0;
    padding: 8px 13px;
    border-top: 1px solid rgba(var(--fg-page-rgb), 0.07);
  }

  .footEnd {
    justify-content: flex-end;
  }

  .door {
    appearance: none;
    -webkit-appearance: none;
    border: 0;
    background: none;
    cursor: pointer;
    padding: 0;
    display: inline-flex;
    align-items: center;
    gap: 3px;
    font-family: var(--font-body);
    font-size: 12.5px;
    font-weight: 500;
    color: var(--accent);
  }

  .door svg {
    width: 12px;
    height: 12px;
    stroke-width: 2.2;
  }

  .time {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 10.5px;
    color: var(--text-tertiary);
  }

  .fold {
    appearance: none;
    -webkit-appearance: none;
    border: 0;
    background: none;
    cursor: pointer;
    width: calc(100% + 26px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 8px -13px 0;
    padding: 8px 13px 0;
    border-top: 1px solid rgba(var(--fg-page-rgb), 0.07);
    font-family: var(--font-body);
    font-size: 12.5px;
    color: var(--text-secondary);
    text-align: left;
  }

  .fold svg {
    width: 12px;
    height: 12px;
    stroke-width: 2.2;
    color: var(--text-tertiary);
    transition: transform 0.32s cubic-bezier(0.32, 0.72, 0, 1);
  }

  .fold[aria-expanded='true'] svg {
    transform: rotate(90deg);
  }

  .foldPage {
    margin-top: 8px;
    white-space: pre-line;
    font-size: 13px;
    color: var(--text-secondary);
  }

  .failNote {
    appearance: none;
    border: 0;
    background: none;
    align-self: flex-end;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 0;
    font-family: var(--font-body);
    font-size: 11px;
    font-weight: 500;
    color: var(--danger);
  }

  button.failNote {
    cursor: pointer;
  }

  .failNote svg {
    width: 12px;
    height: 12px;
    stroke-width: 2;
  }

  /* The failure line opens under its bubble (RevealLine). */
  .failReveal {
    align-self: flex-end;
    --reveal-gap: 8px;
    --reveal-margin: -4px;
  }

  /* The message a banner opened, picked out for a moment in the stream. */
  .flash {
    animation: flash 1.8s ease both;
  }

  @keyframes flash {
    0%,
    45% {
      outline: 2px solid rgba(var(--accent-rgb), 0.6);
      outline-offset: 3px;
    }

    100% {
      outline: 2px solid rgba(var(--accent-rgb), 0);
      outline-offset: 3px;
    }
  }

  .typing {
    flex-shrink: 0;
    margin: 0;
    padding: 0 18px 6px;
    font-family: var(--font-body);
    font-size: 11.5px;
    color: var(--text-tertiary);
  }

  .composer {
    position: relative;
    z-index: 3;
    flex-shrink: 0;
    display: flex;
    align-items: flex-end;
    gap: 8px;
    padding: 8px 16px 18px;
    border-top: 1px solid rgba(var(--fg-page-rgb), 0.06);
  }

  .limit {
    position: absolute;
    left: 16px;
    right: 16px;
    bottom: 100%;
    margin: 0;
    padding: 4px 16px;
    background: var(--bg-page);
    color: var(--danger);
    font-family: var(--font-body);
    font-size: 11.5px;
    font-weight: 600;
  }

  .pill {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    min-height: 44px;
    padding: 11px 16px;
    border-radius: 22px;
    background: var(--glass-bg);
    box-shadow: inset 0 0 0 1px rgba(var(--accent-light-rgb), 0.1);
    cursor: text;
  }

  .input {
    flex: 1;
    min-width: 0;
    display: block;
    margin: 0;
    padding: 0;
    border: 0;
    outline: none;
    resize: none;
    background: transparent;
    color: var(--text-primary);
    caret-color: var(--accent-hot);
    font-family: var(--font-body);
    font-size: 16px;
    line-height: 22px;
    height: 22px;
    max-height: 110px;
    overflow-y: auto;
    scrollbar-width: none;
  }

  .input::placeholder {
    color: var(--text-muted);
  }

  .send {
    flex-shrink: 0;
    cursor: pointer;
    width: 44px;
    height: 44px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    display: grid;
    place-items: center;
    background: linear-gradient(to bottom, var(--accent-light) 0%, var(--accent) 50%, var(--accent-deep) 100%);
    color: var(--text-on-accent);
    box-shadow: 0 6px 18px rgba(var(--accent-shadow-rgb), 0.45);
  }

  .sendIdle {
    background: rgba(var(--accent-rgb), 0.18);
    color: var(--accent);
    box-shadow: none;
    cursor: default;
  }

  .send svg {
    width: 21px;
    height: 21px;
    margin-left: 1px;
    margin-top: -1px;
    overflow: visible;
  }

  /* web-studio-sites D12: on a custom site the panel's head is drawn as her page draws it (telify-pages.html .mpHdr,
     .mpName, .mpRooms and .mpClose): her logo when she has one, the name and the two rooms on the left, a round
     close on the right. */
  :global(:root[data-custom-site]) .hdr {
    display: flex;
    gap: 14px;
    padding: 20px 22px 6px;
  }

  :global(:root[data-custom-site]) .hdr > span:empty {
    display: none;
  }

  :global(:root[data-custom-site]) .who {
    flex: 1;
    text-align: left;
  }

  :global(:root[data-custom-site]) .whoName {
    font-size: 26px;
    letter-spacing: normal;
  }

  :global(:root[data-custom-site]) .rooms {
    justify-content: flex-start;
    font-size: 12.5px;
  }

  :global(:root[data-custom-site]) .close {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border: 1px solid var(--border-soft);
    border-radius: 50%;
    background: none;
    backdrop-filter: none;
    box-shadow: none;
    color: var(--text-secondary);
  }

  @media (prefers-reduced-motion: reduce) {
    .scrim,
    .panel,
    .open .scrim,
    .open .panel {
      transition: none;
    }
  }
}
